'use strict';

import PropTypes from 'prop-types';
import React from 'react';

export default class ProcDropdownMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpened: props.menuOpened,
    };
  }

  componentDidMount() {
    this._onOuterClick = this._onOuterClick.bind(this);
    window.addEventListener('mousedown', this._onOuterClick);
    window.addEventListener('touchstart', this._onOuterClick);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this._onOuterClick);
    window.removeEventListener('touchstart', this._onOuterClick);
  }

  render() {
    return (
      <div
        ref={menu => {
          this.menu = menu;
        }}
        className={`${this.props.menuTopClassName} proc-dropdown-menu-container`}
      >
        <a className={this.props.className} onClick={this._onMenuClick.bind(this)}>
          <i className={this.props.menuIconClassName} />
        </a>
        {this._renderMenuItems()}
      </div>
    );
  }

  _renderMenuItems() {
    if (!this.state.menuOpened) {
      return <span />;
    }
    let clazz = this.props.menuItemClassName || 'proc-menu gray20-border-color';

    return (
      <div className={clazz} onClick={this._onMenuItemClick.bind(this)}>
        {this.props.children}
      </div>
    );
  }

  _onMenuClick() {
    this.setState({ menuOpened: !this.state.menuOpened });
  }

  _onMenuItemClick() {
    this.setState({ menuOpened: false });
  }

  _onOuterClick(event) {
    if (this.state.menuOpened) {
      if (!this.menu.contains(event.target)) {
        this.setState({ menuOpened: false });
      }
    }
  }
}

ProcDropdownMenu.propTypes = {
  className: PropTypes.string,
  menuTopClassName: PropTypes.string,
  menuItemClassName: PropTypes.string,
  menuIconClassName: PropTypes.string,
  menuOpened: PropTypes.bool,
  children: PropTypes.array,
};
